// About — the studio, the people, and why being in this downtown matters.

import React from 'react';
import { Bay, Btn, Card, Eyebrow, Figures, Head, OtherDoor, PhotoStrip } from '../primitives.jsx';
import { useSiteData, aboutPhotos, spacePhotos } from '../data.js';
import { go } from '../routes.js';
import { STUDIO } from '../content.js';

export default function About() {
  const d = useSiteData();
  const { copy, caseStudy, gettingHere } = d;
  const inside = aboutPhotos(d.photos);
  const space = spacePhotos(d.photos);
  const gallery = inside.length ? inside : space;

  return (
    <>
      <Bay band="ground">
        <Eyebrow>About</Eyebrow>
        <h1 className="hddn-h1" style={{ marginTop: 18, maxWidth: '13ch' }}>{copy.aboutTitle}</h1>
        <div className="hddn-prose hddn-lede" style={{ marginTop: 22, maxWidth: '54ch' }}>
          {copy.aboutBody.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </Bay>

      {gallery.length ? (
        <Bay tight>
          <PhotoStrip photos={gallery} alt="Inside the HDDN LAB studio" ratio="wide" limit={10} />
        </Bay>
      ) : null}

      <Bay>
        <Head
          eyebrow="Why here"
          title="Being in this downtown is the whole point."
          lede={copy.localBody}
        />
        <div style={{ marginTop: 'var(--gap)' }}>
          <Figures items={caseStudy.headline.slice(0, 4)} cols={4} />
        </div>
        <p className="hddn-note" style={{ marginTop: 16 }}>
          {caseStudy.months} months running {caseStudy.client}'s social accounts, {caseStudy.window}.
        </p>
      </Bay>

      <Bay band="raised">
        <div className="hddn-grid hddn-grid--sidebar">
          <div>
            <Head eyebrow="The building" title="Behind the tunnel." />
            <p className="hddn-lede" style={{ color: 'var(--ink)', maxWidth: '52ch' }}>{gettingHere.intro}</p>
            <div style={{ marginTop: 22 }}>
              <p className="hddn-label">Getting here</p>
              <ul style={{ marginTop: 12 }}>
                {gettingHere.transit.map((t) => <li key={t} className="hddn-muted" style={{ marginBottom: 8 }}>{t}</li>)}
              </ul>
              <p className="hddn-note" style={{ marginTop: 12 }}>{gettingHere.parkingNote}</p>
            </div>
          </div>
          <Card>
            <p className="hddn-label">Find us</p>
            <address style={{ fontStyle: 'normal', marginTop: 14 }} className="hddn-h4">
              {STUDIO.street}<br />{STUDIO.city}, {STUDIO.state} {STUDIO.zip}
            </address>
            <p className="hddn-muted" style={{ marginTop: 14 }}>{STUDIO.hoursLabel}</p>
            <div style={{ marginTop: 20, display: 'grid', gap: 10 }}>
              <a href={`mailto:${STUDIO.email}`} style={{ color: 'var(--accent-ink)', textDecoration: 'underline' }}>{STUDIO.email}</a>
              <a href={STUDIO.instagram} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-ink)', textDecoration: 'underline' }}>{STUDIO.handle} on Instagram</a>
              <a href={STUDIO.tiktok} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-ink)', textDecoration: 'underline' }}>{STUDIO.handle} on TikTok</a>
            </div>
            <div style={{ marginTop: 24 }}>
              <Btn href="/contact" onClick={go('/contact')} variant="fill" wide>Get in touch</Btn>
            </div>
          </Card>
        </div>
      </Bay>

      <OtherDoor
        k="Three ways in"
        title="Content, a photographer, or the room."
        body="Same building, same gear, same people. Pick whichever one you actually need."
        href="/"
        cta="Pick a door"
      />
    </>
  );
}
